"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DataGrid_1 = __importDefault(require("./DataGrid"));
exports.default = DataGrid_1.default;
